import React, { useState } from 'react';
import logo from '../../assets/Doctor-AI_LOGO.png'; // Make sure your logo is in the assets folder
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/solid'; // For menu icons

const NavPhc = () => {
    // State to manage mobile menu visibility
    const [isOpen, setIsOpen] = useState(false);

    const navLinks = [
        { name: 'Data Privacy', href: '/privacy' },
        { name: 'About Us', href: '/about-us' },
        { name: 'Contact Us', href: '/contact-us' },
    ];

    return (
        <header className="bg-[#0d1c5d] shadow-sm sticky top-0 z-50 ">
            <nav className="px-6 py-3">
                <div className="flex justify-between items-center">
                    {/* Logo */}
                    <a href="/" className="flex-shrink-0">
                        <img src={logo} alt="PHC Logo" className="h-10 w-auto" />
                    </a>

                    {/* Middle Navigation Links - Hidden on Mobile */}
                    <div className="hidden md:flex items-center space-x-8">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                className="text-white hover:text-red-600 font-medium transition-colors duration-300"
                            >
                                {link.name}
                            </a>
                        ))}
                    </div>

                    {/* Right Side: Auth Buttons - Hidden on Mobile */}
                    <div className="hidden md:flex items-center space-x-4">
                        <a
                            href="/login"
                            className="bg-gray-600 text-white font-semibold px-5 py-2 rounded-full hover:bg-gray-900 transition-transform duration-300 transform hover:scale-105"
                        >
                            Sign In
                        </a>
                        <a
                            href="/sign-up"
                            className="bg-red-600 text-white font-semibold px-5 py-2 rounded-full hover:bg-red-700 transition-transform duration-300 transform hover:scale-105"
                        >
                            Sign Up
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center">
                        <button onClick={() => setIsOpen(!isOpen)} className="text-white focus:outline-none">
                            {isOpen ? (
                                <XMarkIcon className="h-6 w-6" />
                            ) : (
                                <Bars3Icon className="h-6 w-6" />
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Dropdown */}
                {isOpen && (
                    <div className="md:hidden mt-4 space-y-2 pb-2">
                        {navLinks.map((link) => (
                             <a
                                key={link.name}
                                href={link.href}
                                className="block px-4 py-2 text-white hover:bg-red-400 rounded-md text-center"
                            >
                                {link.name}
                            </a>
                        ))}
                        
                        <div className="flex flex-col space-y-2 pt-2 px-4">
                            <a
                                href="/login"
                                className="block text-center w-full bg-gray-600 text-white font-semibold px-5 py-2 rounded-full hover:bg-gray-700 transition-colors"
                            >
                                Sign In
                            </a>
                            <a
                                href="/sign-up"
                                className="block text-center w-full bg-red-600 text-white font-semibold px-5 py-2 rounded-full hover:bg-red-700 transition-colors"
                            >
                                Sign Up
                            </a>
                        </div>
                    </div>
                )}
            </nav>
        </header>
    );
};

export default NavPhc;